import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { toArray } from '@kcast-fe/core';
import { Svg } from '../../../../base';
const TriggerBaseFC = ({ items, activeId, isOpen }) => {
    const label = useMemo(() => {
        const activeIds = toArray(activeId);
        if (activeIds.length === 0) {
            return 'Select...';
        }
        else if (activeIds.length === 1) {
            return items.find((i) => i.id === activeIds[0])?.name ?? '';
        }
        else {
            return `${activeIds.length} items`;
        }
    }, [activeId, items]);
    return (_jsxs(Flex, { gap: '4px', _hover: { cursor: 'pointer' }, children: [_jsx(Box, { fontSize: '16px', fontWeight: 600, className: 'cut-text', children: label }), _jsx(Box, { transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform var(--tr-200-ei)', children: _jsx(Svg, { name: 'ArrowDown', size: 's20' }) })] }));
};
export const TriggerBase = memo(TriggerBaseFC);
//# sourceMappingURL=TriggerBase.js.map